import styled, { css } from 'styled-components'

export const AccordionCustomItemStyles = (paddingBottom: number) => {
  return {
    paddingTop: 'var(--space-200)',
    paddingBottom,
  }
}

export const TotalProfitContainer = styled.div`
  width: 100%;
  padding: 0 var(--space-500);
  font-size: var(--font-size-300);
  color: var(--text-secondary);
  display: flex;
  justify-content: flex-end;
`

export const TotalProfitCopy = styled.p<{ top?: number }>`
  max-width: 65%;
  text-align: right;

  ${({ top }) =>
    top &&
    css`
      position: relative;
      top: ${top}px;
    `}
`

export const Heading = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-weight: 600;
`

export const CustomSoldContainer = styled.div`
  display: flex;
  align-items: center;

  span {
    margin-left: var(--space-200);
  }
`

export const QuantityInputContainer = styled.div`
  font-weight: normal;
  width: 125px;
  position: relative;
  overflow: visible;
`

export const QuantityInputError = styled.div`
  position: absolute;
  top: 100%;
  white-space: nowrap;
`

export const AccordionCustomItem = styled.div<{ paddingBottom: number }>`
  padding-bottom: ${({ paddingBottom }) => (paddingBottom ? `${paddingBottom}px` : '0')};
`
